import React from 'react';

import DestinationTypeahead from '@homeaway/react-destination-typeahead';

import {useComponent} from './hooks';

import './SearchDestinationField.less';

function SearchDestinationField() {
    const {
        className,
        appPrefix,
        baseUrl,
        filterType,
        googlePlaceApiKey,
        googlePlaceApiUrl,
        hideSelectedFilter,
        highlightMode,
        icon,
        id,
        isMobile,
        isTypeaheadInputFocus,
        locale,
        matchMode,
        messages,
        minLength,
        onBlur,
        onFocus,
        onMount,
        onSearchSelected,
        popoverDesktopMaxWidth,
        popoverDesktopMinMarginRight,
        popoverDesktopMinWidth,
        popoverDesktopWidth,
        popoverMaxDisplayCount,
        popoverMaxDisplayCountMobile,
        recentSearchesDisplayMax,
        remotePath,
        retainUserInput,
        search,
        showInlineSuggestion,
        showRecentSearches,
        showResultIcons,
        showResultLabels,
        showSpinner,
        showTrendingSuggestions,
        site,
        truncateResultTerms,
        usePopoverAnimation,
        useResultsAnimation
    } = useComponent();

    return (
        <div className={className}>
            <DestinationTypeahead
                appPrefix={appPrefix}
                baseUrl={baseUrl}
                filterType={filterType}
                googlePlaceApiKey={googlePlaceApiKey}
                googlePlaceApiUrl={googlePlaceApiUrl}
                hideSelectedFilter={hideSelectedFilter}
                highlightMode={highlightMode}
                icon={icon}
                id={id}
                isMobile={isMobile}
                isTypeaheadInputFocus={isTypeaheadInputFocus}
                locale={locale}
                matchMode={matchMode}
                messages={messages}
                minLength={minLength}
                onBlur={onBlur}
                onFocus={onFocus}
                onMount={onMount}
                onSearchSelected={onSearchSelected}
                popoverDesktopMaxWidth={popoverDesktopMaxWidth}
                popoverDesktopMinMarginRight={popoverDesktopMinMarginRight}
                popoverDesktopMinWidth={popoverDesktopMinWidth}
                popoverDesktopWidth={popoverDesktopWidth}
                popoverMaxDisplayCount={popoverMaxDisplayCount}
                popoverMaxDisplayCountMobile={popoverMaxDisplayCountMobile}
                recentSearchesDisplayMax={recentSearchesDisplayMax}
                remotePath={remotePath}
                retainUserInput={retainUserInput}
                search={search}
                showInlineSuggestion={showInlineSuggestion}
                showRecentSearches={showRecentSearches}
                showResultIcons={showResultIcons}
                showResultLabels={showResultLabels}
                showSpinner={showSpinner}
                showTrendingSuggestions={showTrendingSuggestions}
                site={site}
                truncateResultTerms={truncateResultTerms}
                usePopoverAnimation={usePopoverAnimation}
                useResultsAnimation={useResultsAnimation}
            />
        </div>
    );
}

export {SearchDestinationField};
